export var VehicleSelectionHierarchyLabel;
(function (VehicleSelectionHierarchyLabel) {
    VehicleSelectionHierarchyLabel["Types"] = "Types";
    VehicleSelectionHierarchyLabel["Years"] = "Years";
    VehicleSelectionHierarchyLabel["Makes"] = "Makes";
    VehicleSelectionHierarchyLabel["Models"] = "Models";
    VehicleSelectionHierarchyLabel["SubModels"] = "SubModels";
    VehicleSelectionHierarchyLabel["BodyStyles"] = "BodyStyles";
    VehicleSelectionHierarchyLabel["Engines"] = "Engines";
    VehicleSelectionHierarchyLabel["Transmissions"] = "Transmissions";
    VehicleSelectionHierarchyLabel["DriveTrains"] = "DriveTrains";
})(VehicleSelectionHierarchyLabel || (VehicleSelectionHierarchyLabel = {}));
/**
 * The vehicle selection method options available to the user.
 */
export var VehicleSelectionMethod;
(function (VehicleSelectionMethod) {
    VehicleSelectionMethod["VinDecode"] = "VINDECODE";
    VehicleSelectionMethod["Assisted"] = "ASSISTED";
    VehicleSelectionMethod["ServiceDecode"] = "SERVICEDECODE";
    VehicleSelectionMethod["GenericVehicle"] = "GENERICVEHICLE";
})(VehicleSelectionMethod || (VehicleSelectionMethod = {}));
/**
 * The vehicle identification failure codes that drives the error banner in VIM
 */
export var VehicleIdentificationErrorCode;
(function (VehicleIdentificationErrorCode) {
    VehicleIdentificationErrorCode["VinDecodeFailure"] = "VSM_VIN";
    VehicleIdentificationErrorCode["SelectionFailure"] = "VSM";
    VehicleIdentificationErrorCode["Default"] = "";
    /**
     * The enums are to be removed when VIM will be migrate to react and will be replaced with action ids from redux.
     */
})(VehicleIdentificationErrorCode || (VehicleIdentificationErrorCode = {}));
//# sourceMappingURL=enums.js.map